let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("90sCJ")).then(() => parcelRequire('itJvv'));